module.exports = __webpack_public_path__ + "static/it_services__reports-918a74029966f4fac6cfea58f61bff34.png";